<template>
  <v-container
    fluid
    mt-1
    p-0
    color="primary"
  >
    <v-layout column>
      <v-toolbar
        v-if="title"
        width="100%"
      >
        <v-toolbar-title class="heading landing-news-title">
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>

      <v-divider v-if="title" />

      <v-layout
        :class="{
          column: $vuetify.breakpoint.mdAndDown,
          row: $vuetify.breakpoint.lgAndUp
        }"
        wrap
        justify-center
        class="landing-posts-container"
      >
        <!-- Post Cards -->
        <v-flex
          v-for="post in posts[page]"
          :key="post.slug"
          :class="{
            lg7: $vuetify.breakpoint.lgAndUp && posts[page].length === 1,
            lg4: posts[page].length > 1
          }"
          tabindex="0"
          role="button"
          :aria-label="`Open post titled ${post.title}`"
          @click="showDialog(post.slug)"
          @keydown.enter="showDialog(post.slug)"
          @keydown.space.prevent="showDialog(post.slug)"
        >
          <v-card
            elevation="1"
            class="landing-post"
            :ripple="true"
            color="primary"
          >
            <v-img
              v-if="post.full_picture"
              :src="post.full_picture"
              :alt="`Image for post titled ${post.title}`"
              position="top center"
              height="100px"
            />

            <v-card-title class="landing-post-title">
              <div>
                <div
                  class="h6 font-weight-light p-1"
                  v-html="post.title"
                />
                <a
                  :href="toPostLink(post.slug)"
                >
                  <span class="grey--text text-subtitle-2">
                    {{ post.date }}
                  </span>
                </a>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>

        <!-- Pagination Navigation -->
        <v-layout
          v-if="posts.length && !isLoading"
          pt-5
          pb-8
          text-center
          full-width
          justify-center
          tag="nav"
          aria-label="Posts Pagination"
        >
          <v-flex xs12>
            <v-pagination
              v-model="page"
              :length="posts.length - 1"
              :total-visible="perPage - 1"
              color="accent"
              next-icon="fad fa-chevron-right"
              prev-icon="fad fa-chevron-left"
              aria-label="Pagination navigation"
            />
          </v-flex>
        </v-layout>

        <!-- Loading Spinner -->
        <v-flex
          v-if="isLoading"
          xs12
          sm12
          md12
          lg6
          pt-8
          pb-8
          full-width
          align-middle
          justify-middle
          text-center
          column
        >
          <v-btn
            aria-label="Loading"
            role="progressbar"
            icon
            large
            disabled
          >
            <v-icon>fal fa-circle-notch fa-spin</v-icon>
          </v-btn>
        </v-flex>

        <!-- No Posts Found -->
        <v-flex
          v-if="posts.length === 0 && !isLoading"
          xs12
          sm12
          md12
          lg11
          pt-8
          pb-8
          full-width
          align-middle
          justify-middle
          text-center
          column
        >
          <v-card
            elevation="1"
            color="primary"
          >
            <v-card-text>
              {{ $t('components.posts.noPosts') }}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

import { toPostLink as asPostLink } from "@/utils/post.utils";
import config from "@/constants/config";
import types from '@/constants/types';

export default {
    name: "Posts",
    props: {
        posts: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: ''
        },
        isLoading: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            page: 1,
            perPage: config.postsPerPage,
        }
    },
    methods: {
        ...mapActions({
            showPostDialog: types.UPDATE_COMPONENT_VISIBILITY
        }),

        toLink(link) {
            window.open(link);
        },
        toPostLink(slug) {
            return asPostLink(slug);
        },
        showDialog(slug) {
            this.showPostDialog({
                dialog: {
                    post: this.posts.flat().find(post => post.slug === slug) || {}
                }
            });
        }
    }
};
</script>
